/** Synthetic resource-validation scenes must not impose public ID/name rules on
 * native documents. Reserve table IDs without interpreting malformed tables;
 * the public validator still rejects those tables. Never use these IDs for export.
 */
export function resourceValidationIds(...tables: unknown[]): () => string {
  const claimed = new Set<string>();
  for (const table of tables) {
    if (!Array.isArray(table)) continue;
    for (const item of table) {
      if (item && typeof item === 'object' && typeof (item as { id?: unknown }).id === 'string') claimed.add((item as { id: string }).id);
    }
  }
  let index = 0;
  return () => {
    let id: string;
    do { id = `native-resource-${index++}`; } while (claimed.has(id));
    claimed.add(id);
    return id;
  };
}
